module.exports = __webpack_public_path__ + "img/cuizhiqiang.3b9d4203.png";